import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QaroniAnimationComponent } from './qaroni-animation.component';

@NgModule({
  declarations: [QaroniAnimationComponent],
  imports: [CommonModule],
  exports: [QaroniAnimationComponent],
})
export class QaroniAnimationModule {}
